import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCollectionPlaylists, checkUncheckPlaylist, deleteFromArrangements } from '../../../actions/collection';
import { ClientSidePaginationListEasy } from '../../../hoc/ClientSidePaginationListEasy.jsx';
import { getVisibleCollectionOffers } from '../../../reducers/collection-selector';
import ArrangementItem from './Arrangement/ArrangementItem.jsx';
import FilterSet from '../../common/Filters/FilterSet.jsx';
import { Redirect } from 'react-router-dom';
import { CABINET_SLUG } from '../../../../config';


const ArrangementsList = ({ isLoading, count, paginateList, list, arrangementPlaylists, can_open_online,
                            payment_service, playlists, redirectTo, performerFilter,
                            getCollectionPlaylists, checkUncheckPlaylist, deleteFromArrangements }) => {
  const [redirect, setRedirect] = useState(false);

  useEffect(() => { getCollectionPlaylists() }, []);

  const handleDelete = (ids) => { deleteFromArrangements(ids); }
  const handlePlaylistChange = (offer, playlist, checked) => { checkUncheckPlaylist({offer, playlist, checked}); }

  let items;
  if (!isLoading) {
    if (count){
      items = paginateList.map(i => <ArrangementItem key={ i.id }
                                             {...i.offer_info}
                                             downLoadUrl={ i.purchase_file_url }
                                             onDelete={ handleDelete }
                                             onPlaylistChange={ handlePlaylistChange }
                                             playlists={ playlists }
                                             inPlaylists={ arrangementPlaylists[i.offer_info.id] }
                                             user_can_open_online={ can_open_online }
                                             payment_service={ payment_service }/>)
    } else {
      items = <p>{ gettext('Ничего не найдено.') }</p>;
    }
  }

  if (redirect && redirectTo) return <Redirect to={`/${lang}/${CABINET_SLUG}/collection/${redirectTo}/`}/>

  return <div>
    <FilterSet isLoading={ isLoading }
               list={ list }
               authorFilter={ performerFilter ? false : true }
               performerFilter={ performerFilter || false }
               difficultyFilter={ true }
               tonalityFilter={ true }
               colSize={ 4 }/>
    { items }
  </div>
}

ArrangementsList.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  count: PropTypes.number.isRequired,
  list: PropTypes.array.isRequired,
  paginateList: PropTypes.array.isRequired,
  can_open_online: PropTypes.bool.isRequired,
  redirectTo: PropTypes.string.isRequired,
  performerFilter: PropTypes.bool,
  loadListFromServer: PropTypes.func.isRequired,

  getCollectionPlaylists: PropTypes.func.isRequired,
  checkUncheckPlaylist: PropTypes.func.isRequired,
  deleteFromArrangements: PropTypes.func.isRequired,
}

let mapStateToProps = (state) => {
  return {
    list: getVisibleCollectionOffers(state),
    playlists: state.collection.playlists,
    arrangementPlaylists: state.collection.arrangementPlaylists,
    can_open_online: state.auth.can_open_online,
    payment_service: state.auth.payment_service,
  }
};

export default compose(
  connect(mapStateToProps, { getCollectionPlaylists, checkUncheckPlaylist, deleteFromArrangements }),
  ClientSidePaginationListEasy
)(ArrangementsList);

